import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {ArchitectureStructureSettingModel} from '../../../../models/ArchitectureStructureSettingModel';
import {DesignServicesModel} from '../../../../models/DesignServicesModel';
import {UnitsModel} from '../../../../models/UnitsModel';
import {LayerModel} from '../../../../models/LayerModel';
import {L1Model} from '../../../../models/L1Model';
import {L2Model} from '../../../../models/L2Model';
import {L3Model} from '../../../../models/L3Model';
import {Subscription} from 'rxjs';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ArchitectureStructureService} from '../service/architecture-structure.service';
import * as toastr from 'toastr';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import {ProviderModel} from '../../../../models/ProviderModel';
import {SizeModel} from '../../../../models/SizeModel';
import {SiteModel} from '../../../../models/SiteModel';

@Component({
  selector: 'app-edit-architecture-structure',
  templateUrl: './edit-architecture-structure.component.html',
  styleUrls: ['./edit-architecture-structure.component.scss']
})
export class EditArchitectureStructureComponent extends ProjectConstants implements OnInit, OnDestroy {

  showActions: boolean;
  showDS: boolean;
  showL1: boolean;
  showL2: boolean;
  showL3: boolean;
  showLayer: boolean;
  showUnits: boolean;
  showRU: boolean;
  showProvider: boolean;
  showSize: boolean;
  showSite: boolean;

  architectureStructureSetting: ArchitectureStructureSettingModel;
  designServicesSelect: DesignServicesModel;
  unitSelect: UnitsModel;
  layerSelect: LayerModel;
  l1Select: L1Model;
  l2Select: L2Model;
  l3Select: L3Model;
  resourceUnitSelect: ResourcesUnitModel;
  providerSelect: ProviderModel;
  sizeSelect: SizeModel;
  siteSelect: SiteModel;
  saveArchitectureStructure: Subscription;
  parameterSubscribe: Subscription;

  registerForm: FormGroup;
  submitted = false;
  architectureStructureJson: any;


  constructor(private route: ActivatedRoute, private router: Router,
              private architectureStructureSettingService: ArchitectureStructureService,
              private formBuilder: FormBuilder) {
    super();

    this.showActions = false;
    this.showDS = false;
    this.showL1 = false;
    this.showL2 = false;
    this.showL3 = false;
    this.showLayer = false;
    this.showUnits = false;
    this.showRU = false;
    this.showProvider = false;
    this.showSize = false;
    this.showSite = false;

    this.designServicesSelect = new DesignServicesModel();
    this.unitSelect = new UnitsModel();
    this.layerSelect = new LayerModel();
    this.l1Select = new L1Model();
    this.l2Select = new L2Model();
    this.l3Select = new L3Model();
    this.resourceUnitSelect = new ResourcesUnitModel();
    this.providerSelect = new ProviderModel();
    this.sizeSelect = new SizeModel();
    this.siteSelect = new SiteModel();
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.architectureStructureJson = params['row'];
      });

    this.architectureStructureSetting = JSON.parse(this.architectureStructureJson) as ArchitectureStructureSettingModel;
    this.designServicesSelect = this.architectureStructureSetting.designServices;
    this.unitSelect = this.architectureStructureSetting.units;
    this.layerSelect = this.architectureStructureSetting.layer;
    this.l1Select = this.architectureStructureSetting.l1;
    this.l2Select = this.architectureStructureSetting.l2;
    this.l3Select = this.architectureStructureSetting.l3;
    this.resourceUnitSelect = this.architectureStructureSetting.resourceUnit;
    this.providerSelect = this.architectureStructureSetting.provider;
    this.sizeSelect = this.architectureStructureSetting.size;
    this.siteSelect = this.architectureStructureSetting.site;

    this.registerForm = this.formBuilder.group({
      providerCod: [{value: '', disabled: false}, Validators.required],
      designServicesCod: [{value: '', disabled: false}, Validators.required],
      layerCod: [{value: '', disabled: false}],
      l1Cod: [{value: '', disabled: false}],
      l2Cod: [{value: '', disabled: false}],
      l3Cod: [{value: '', disabled: false}],
      resourceUnitCod: [{value: '', disabled: false}, Validators.required],
      unitCod: [{value: '', disabled: false}],
      sizeCod: [{value: '', disabled: false}],
      siteCod: [{value: '', disabled: false}]
    });

    this.registerForm.patchValue({
      providerCod: this.providerSelect ? this.providerSelect.cod : ''
    });

    this.registerForm.patchValue({
      designServicesCod: this.designServicesSelect ? this.designServicesSelect.cod : ''
    });

    this.registerForm.patchValue({
      unitCod: this.unitSelect ? this.unitSelect .cod : ''
    });

    this.registerForm.patchValue({
      layerCod: this.layerSelect ? this.layerSelect.cod : ''
    });

    this.registerForm.patchValue({
      l1Cod: this.l1Select ? this.l1Select.cod : ''
    });

    this.registerForm.patchValue({
      l2Cod: this.l2Select ? this.l2Select.cod : ''
    });

    this.registerForm.patchValue({
      l3Cod: this.l3Select ? this.l3Select.cod : ''
    });

    this.registerForm.patchValue({
      resourceUnitCod: this.resourceUnitSelect ? this.resourceUnitSelect.cod : ''
    });

    this.registerForm.patchValue({
      sizeCod: this.sizeSelect ? this.sizeSelect.cod : ''
    });

    this.registerForm.patchValue({
      siteCod: this.siteSelect ? this.siteSelect.cod : ''
    });
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.SETTINGS], {queryParams: {selectedIndex: 2}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.saveArchitectureStructure = this.architectureStructureSettingService
        .update(this.architectureStructureSettingService.baseUrl, this.architectureStructureSetting)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, Resource Unit already exists', 'Warning');
            } else if (result === -2) {
              toastr.options.timeout = 5000;
              toastr.warning('Element already used', 'Warning');
            } else {
              toastr.success('Architecture Structure Setting was created with success', 'Success');
              this.router.navigate([this.LINKS.SETTINGS], {queryParams: {selectedIndex: 2}});
            }
          },
          error => {
            toastr.error('Architecture Structure Setting was not created', 'Error');
          });
    }
  }

  ngOnDestroy(): void {
    if (this.saveArchitectureStructure) {
      this.saveArchitectureStructure.unsubscribe();
    }
    if (this.parameterSubscribe) {
      this.parameterSubscribe.unsubscribe();
    }
  }

  getElementSelectedDesignServices($event) {
    this.architectureStructureSetting.designServices = $event.row;
    this.designServicesSelect = $event.row;
    this.registerForm.patchValue({
      designServicesCod: this.designServicesSelect.cod
    });
  }

  getElementSelectedUnits($event) {
    this.architectureStructureSetting.units = $event.row;
    this.unitSelect = $event.row;
    this.registerForm.patchValue({
      unitsCod: this.unitSelect.cod
    });
  }

  getElementSelectedLayer($event) {
    this.architectureStructureSetting.layer = $event.row;
    this.layerSelect = $event.row;
    this.registerForm.patchValue({
      layerCod: this.layerSelect.cod
    });
  }

  getElementSelectedL1($event) {
    this.architectureStructureSetting.l1 = $event.row;
    this.l1Select = $event.row;
    this.registerForm.patchValue({
      l1Cod: this.l1Select.cod
    });
  }

  getElementSelectedL2($event) {
    this.architectureStructureSetting.l2 = $event.row;
    this.l2Select = $event.row;
    this.registerForm.patchValue({
      l2Cod: this.l2Select.cod
    });
  }

  getElementSelectedL3($event) {
    this.architectureStructureSetting.l3 = $event.row;
    this.l3Select = $event.row;
    this.registerForm.patchValue({
      l3Cod: this.l3Select.cod
    });
  }

  getElementSelectedResourceUnit($event: any) {
    this.architectureStructureSetting.resourceUnit = $event.row;
    this.resourceUnitSelect = $event.row;
    this.registerForm.patchValue({
      resourceUnitCod: this.resourceUnitSelect.cod
    });
  }

  getElementSelectedProvider($event: any) {
    this.architectureStructureSetting.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      providerCod: this.providerSelect.cod
    });
  }

  getElementSelectedSize($event: any) {
    this.architectureStructureSetting.size = $event.row;
    this.sizeSelect = $event.row;
    this.registerForm.patchValue({
      sizeCod: this.sizeSelect.cod
    });
  }

  getElementSelectedSite($event: any) {
    this.architectureStructureSetting.site = $event.row;
    this.siteSelect = $event.row;
    this.registerForm.patchValue({
      siteCod: this.siteSelect.cod
    });
  }

  toggleDS() {
    this.showDS = !this.showDS;
  }

  toggleL1() {
    this.showL1 = !this.showL1;
  }

  toggleL2() {
    this.showL2 = !this.showL2;
  }

  toggleL3() {
    this.showL3 = !this.showL3;
  }

  toggleLayer() {
    this.showLayer = !this.showLayer;
  }

  toggleUnits() {
    this.showUnits = !this.showUnits;
  }

  toggleRU() {
    this.showRU = !this.showRU;
  }

  toggleProvider() {
    this.showProvider = !this.showProvider;
  }

  toggleSize() {
    this.showSize = !this.showSize;
  }

  toggleSite() {
    this.showSite = !this.showSite;
  }


  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }


  resetDesignServices() {
    this.registerForm.patchValue({
      designServicesCod: ''
    });
    this.designServicesSelect = new DesignServicesModel();
  }

  resetUnit() {
    this.registerForm.patchValue({
      unitCod: ''
    });
    this.unitSelect = new UnitsModel();
  }

  resetLayer() {
    this.registerForm.patchValue({
      layerCod: ''
    });
    this.layerSelect = new LayerModel();
  }

  resetL1() {
    this.registerForm.patchValue({
      l1cod: ''
    });
    this.l1Select = new L1Model();
  }

  resetL2() {
    this.registerForm.patchValue({
      l2cod: ''
    });
    this.l2Select = new L2Model();
  }

  resetL3() {
    this.registerForm.patchValue({
      l3cod: ''
    });
    this.l3Select = new L3Model();
  }

  resetResourceUnit() {
    this.registerForm.patchValue({
      resourceUnitCod: ''
    });
    this.resourceUnitSelect = new ResourcesUnitModel();
  }

  resetProvider() {
    this.registerForm.patchValue({
      providerCod: ''
    });
    this.providerSelect = new ProviderModel();
  }

  resetSize() {
    this.registerForm.patchValue({
      sizeCod: ''
    });
    this.sizeSelect = new SizeModel();
  }

  resetSite() {
    this.registerForm.patchValue({
      siteCod: ''
    });
    this.siteSelect = new SiteModel();
  }

  reset(){
    this.resetProvider();
    this.resetResourceUnit();
    this.resetDesignServices();
    this.resetLayer();
    this.resetL1();
    this.resetL2();
    this.resetL3();
    this.resetUnit();
    this.resetSite();
    this.resetSize();
  }

  isValidInput(value: AbstractControl) {
    if (value.value !== null) {
      if (value.value !== '' && value.valid) {
        return 'is-valid';
      } else {
        return 'is-invalid';
      }
    } else {
      return 'is-invalid';
    }
  }
}

